/* Created By Mr.Priyank Saini */
(function(scope) {
    let cData = {},
        m1 = "Channel ",
        m2 = " doesn't exist yet!",
        m3 = " already exists!",
        m4 = "Subscription ID ",
        m5 = " is not available!",
        m6 = "Please pass subscrption ID to unsubscribe!",
        sarc = {
            channelInstall: (cn) => cData[cn] ? console.log(m1 + cn + m3) : cData[cn] = {},
            channelUninstall: (cn) => cData[cn] ? delete cData[cn] : console.log(m1 + cn + m2),
            channelBroadcast: (cn, arg, si,cxt) => {
                let res = [];
                try {
                    if(cData[cn]){
                        if(si && cData[cn][si]){
                            cData[cn][si].forEach((cb)=>{
                                res.push({
                                    "sId":si,
                                    "res":cb.call(cxt,arg)
                                })
                            })
                        }
                        else if(cData[cn].g){
                            cData[cn].g.forEach((cb)=>{
                                res.push({
                                    "sId":"general",
                                    "res":cb.call(cxt,arg)
                                })
                            })
                        }
                    }else{
                        res = null;
                    }
                } catch (err) {
                    res = new Error("Exception occured in: "+ cn)
                    console.warn("Exception occured in: ", cData[cn], err)
                }
                return res;
            },
            channelSubscription: (cn, cb, si) =>{
                if(!cData[cn]){
                    console.log(m1 + cn + m2);
                    cData[cn] = {};
                }
                cData[cn][si||"g"] = cData[cn][si||"g"] ? cData[cn][si||"g"] : [];
                cData[cn][si||"g"].push(cb);
            },
            channelUnsubscription: (cn, si)=> {
                if(si)
                    if(cData[cn])
                        if(cData[cn][si])
                            delete cData[cn][si];
                        else
                            console.log(m4+si+m5)
                    else
                        console.log(m1+cn+m2)
                else
                    console.log(m6);
            },
            getActiveChannels: () => Object.keys(cData),
            isActiveChannel: (cn) => new Boolean(cData && cData[cn]),
            isActiveSubscription: (cn,si) => new Boolean(cData&& cData[cn] && cData[cn][si]),
            getActiveSubscriptions: (cn) => cData && cData[cn] && Object.keys(cData[cn])
        };
    scope.sarc = sarc;
})(window);
//Dummy uses
// sarc.channelInstall("zeetv");
//
// sarc.channelSubscription("zeetv",(whatsnew)=>{
//     console.log(whatsnew);
//     if(whatsnew == "pragya died"){
//         return "Are you kidding me... Noooo.."
//     }else{
//         return "Nice episode";
//     }
// },"kumkumBhagya");
//
// sarc.channelSubscription("zeetv",(ad)=>{
//     console.log(ad);
//     return "I don't like ads";
// })
//
// let userFeedback1 = sarc.channelBroadcast("zeetv","abhishek lost his memory","kumkumBhagya");
// let userFeedback2 = sarc.channelBroadcast("zeetv","pragya died","kumkumBhagya");
// let userFeedback3 = sarc.channelBroadcast("zeetv","Covid-19 related ad");
// console.log(userFeedback1,userFeedback2,userFeedback3)